import { render, staticRenderFns } from "./secretariats.vue?vue&type=template&id=ee2e83ca&scoped=true"
import script from "./secretariats.vue?vue&type=script&lang=js"
export * from "./secretariats.vue?vue&type=script&lang=js"
import style0 from "./secretariats.vue?vue&type=style&index=0&id=ee2e83ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2e83ca",
  null
  
)

export default component.exports